<div class="login">
    <div class="login__wrapper">
        <h2 class="login__title"
            [translate]="parseTypeToken === typeTokenEnum.SET_NEW_PASSWORD
        ? 'auth.reset.changeTitle' : 'auth.reset.title'"></h2>

        @let status = (authStatus$ | async)?.status;

        @if (status === APP_HTTP_STATUS.SUCCESS || status === APP_HTTP_STATUS.TWO_FACTOR_AUTHENTICATION_REQUIRED) {

            <form class="login__form" [formGroup]="form" novalidate>

                @for (item of formArray; track $index) {

                    @if (item.name === formTypeEnum.password) {

                        <div class="login__form-item">
                            <label class="login__form-label" [translate]="item.title"></label>
                            <input
                                data-testid="auth-reset-password"
                                [type]="item.isVisible ? 'text' : 'password'"
                                [class.login__form-input--middle]="strength === 1"
                                [class.login__form-input--strong]="strength > 1"
                                class="login__form-input"
                                minlength="6"
                                maxlength="50"
                                [placeholder]="parseTypeToken === typeTokenEnum.SET_NEW_PASSWORD
                    ? ('auth.reset.setPasswordPlaceholder' | translate) : ('auth.reset.passwordPlaceholder' | translate)"
                                [formControlName]="item.name"
                                appTrimInput>
                            <div class="login__icon-eyes" (click)="item.isVisible = !item.isVisible">
                                <svg-icon
                                    [src]="!item.isVisible ? './assets/design/icons/eyes.svg' : './assets/design/icons/eyes-close.svg'"></svg-icon>
                            </div>
                            <p class="login__form-error"
                               [class.login__form-error--middle]="strength === 1"
                               [class.login__form-error--default]="strength === -1"
                               [class.login__form-error--error]="strength === 0"
                               [class.login__form-error--success]="strength > 1">
                                <span *ngIf="strength < 1" [translate]="'auth.reset.passwordNote'"></span>
                                <span *ngIf="strength === 1" [translate]="'auth.reset.passwordBetter'"></span>
                                <span *ngIf="strength === 2" [translate]="'auth.reset.passwordBest'"></span>

                            </p>

                        </div>

                    }


                    @if (item.name === formTypeEnum.repeat) {

                        <div class="login__form-item">
                            <label class="login__form-label" [translate]="item.title">*</label>
                            <input class="login__form-input"
                                   data-testid="auth-reset-password-repeat"
                                   [placeholder]="parseTypeToken === typeTokenEnum.SET_NEW_PASSWORD
                       ? ('auth.reset.repeatSetPasswordPlaceholder' | translate) : ('auth.reset.repeatPlaceholder' | translate)"
                                   [formControlName]="item.name"
                                   minlength="6"
                                   maxlength="50"
                                   [type]="item.isVisible ? 'text' : 'password'"
                                   appTrimInput>
                            <div class="login__icon-eyes" (click)="item.isVisible = !item.isVisible">
                                <svg-icon
                                    [src]="!item.isVisible ? './assets/design/icons/eyes.svg' : './assets/design/icons/eyes-close.svg'"></svg-icon>
                            </div>
                            <p class="login__form-error"
                               *ngIf="form.controls['repeat'].invalid && form.controls['repeat'].touched"
                               [translate]="'auth.reset.repeatError'"></p>

                        </div>

                    }

                }


                @if (status === APP_HTTP_STATUS.TWO_FACTOR_AUTHENTICATION_REQUIRED) {
                    <div class="login__form-item">
                        <label class="login__form-label" for="auth"
                               [translate]="'profile.authenticationPopup.titleCode'"></label>
                        <input [(ngModel)]="authToken"
                               [placeholder]="'auth.reset.twoAuthPlaceholder' | translate" type="text"
                               id="auth"
                               formControlName="twoAuth"
                               class="login__form-input"
                               appTrimInput>
                    </div>
                }

                <div class="login__form-activity">
                    <div class="login__form-activity-item">
                        <div class="login__form-activity-column">
                            <button
                                data-testid="auth-reset-submit"
                                [disabled]="!form.valid || !form.controls['password'].valid || !form.controls['repeat'].valid || status === APP_HTTP_STATUS.TWO_FACTOR_AUTHENTICATION_REQUIRED && !authToken?.length"
                                class="login__form-sign-btn"
                                (click)="reset()"
                                [accessKey]="'enter'"
                                [translate]="parseTypeToken === typeTokenEnum.SET_NEW_PASSWORD
                            ? 'btns.setPassword' : 'btns.resumePassword'"></button>
                        </div>
                    </div>
                </div>
            </form>

        } @else {
            <div class="login__invalid-token">
                <div class="login__invalid-token-message" [translate]="'auth.reset.invalidToken'"></div>
                <button class="login__invalid-token-btn btn btn--red"
                        [translate]="'btns.tryAgain'"
                        [accessKey]="'enter'"
                        (click)="moveToForgot()"></button>
            </div>
        }

    </div>
</div>
